import { Outlet } from "react-router-dom";
import NavBarr from "./navbar";
import NavBarrr from "./nav";
import { useEffect } from "react";
import { socket } from "./socket";
import { toast } from "react-toastify";

const drawerWidth = 10;

const Layout = () => {
    useEffect(() => {
        // 🟢 عند الاتصال
        socket.on("connect", () => {
            console.log("🟢 Socket connected:", socket.id || "(waiting id...)");
        });

        // 💬 عند استقبال رسالة جديدة
        socket.on("newMessage", (msg) => {
            if (!msg) return;
            console.log("💬 رسالة جديدة:", msg);

            toast.info(
                `💬 رسالة جديدة من ${msg.profileName || msg.from}: ${msg.body || "بدون نص"
                }`,
                {
                    position: "bottom-right",
                    autoClose: 5000,
                    theme: "colored",
                }
            );
        });

        socket.on("disconnect", () => {
            console.log("🔴 Socket disconnected");
        });

        // ✅ نوقف فقط listener مش الاتصال
        return () => {
            socket.off("connect");
            socket.off("newMessage");
            socket.off("disconnect");
        };
    }, []);

    return (
        <div style={{ display: "flex" }}>
            <NavBarr />
            <div style={{ flexGrow: 1, marginLeft: `${drawerWidth}px` }}>
                <NavBarrr />
                <div style={{ padding: "9px" }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;
